// extracted by mini-css-extract-plugin
export default {"title":"N--z","warning":"O--z","sizeOptionsLegendText":"P--z"};